import React, { Component } from 'react'
import Layout from 'components/Layout'
import {
	ReclamationItemIndexTitle,
	ReclamationItemIndexSubTitle,
	Description,
	Title,
	ControlsWrapper,
	ControlsWrapperItem,
} from './style'
import {
	PreviewItemsWrapper,
	ItemPreviewFlowSegment,
	ItemPreviewFlowSegmentTitle,
	ItemPreviewFlowSegmentBody,
} from 'components/ItemPreview/style'
import { connect } from 'react-redux'
import Separator from 'components/Separator'
import ItemPreview from 'components/ItemPreview'
import ReclamationReasonCondition from 'components/ReclamationReasonCondition'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
	setFlowStepperStep,
	addReasonCondition,
	getPartialSteps,
	addReclamationComment,
	addReclamationImages,
	clearReclamationImages,
	getFAQs,
} from 'components/Steps/thunk'
import { clearShippingOptions } from 'components/Steps/slices'
import {
	getTokenData,
	getShopPropertiesName,
	SS,
	getItemsArray,
} from 'utils/common'
import UploadPhoto from 'components/UploadPhoto'
import { ButtonBorder, ButtonFull } from 'components/Form/Button'
import {
	addContinueUrl,
	addBackUrl,
	updateContinueState,
} from 'components/Footer/thunk'
import config from 'configs/config'
import { removeItemFlow } from 'components/Steps/slices'
import ReclamationContactForm from 'components/ReclamationContactForm'
import { PopupWindow } from 'components/Modal'
import Accordions from 'components/Accordions'
import {
	markFieldToHighlight,
	unmarkFieldToHighlight,
	setFieldToHighlightInToDefault,
} from './thunk'
import { clearContactFromMessageSuccess } from 'components/ReclamationContactForm/slices'
import { bindActionCreators, compose } from 'redux'
import FAQPreview from 'components/FAQPreview'
import StepsAnimation from 'components/StepsAnimation'

const DIDNT_ARRIVE = 'DIDNT_ARRIVE'
const INCORRECT_ITEM = 'RECEIVED_INCORRECT_ITEM_COMPLAINT'

/**
 * isReclamationItemHandled {Function}
 * @description - define is current item is handled and continue button is active
 * @return {Boolean}
 * */
const isReclamationItemHandled = (item = {}) => {
	if (item.returnOrderItemConditionApiKey === DIDNT_ARRIVE) {
		if (
			item.reclamationReasonApiKey &&
			item.returnOrderItemConditionApiKey &&
			item.comment
		) {
			return true
		}
	}

	if (item.reclamationReasonApiKey === INCORRECT_ITEM) {
		if (
			item.reclamationReasonApiKey &&
			item.returnOrderItemConditionApiKey &&
			item.comment
		) {
			return true
		}
	}

	if (
		item.returnOrderItemConditionApiKey !== DIDNT_ARRIVE &&
		item.reclamationReasonApiKey !== INCORRECT_ITEM
	) {
		if (
			item.reclamationReasonApiKey &&
			item.returnOrderItemConditionApiKey &&
			item.reclamationImages &&
			item.reclamationImages.length &&
			item.comment
		) {
			return true
		}
	}

	return false
}

/**
 * getItemsReclamation {Function}
 * @description - get reclamation items
 *
 * */
const getItemsReclamation = (items) => {
	let exchangeObj = {}
	for (let [key, value] of Object.entries(items.exchange)) {
		if (value?.flowSteps?.includes(config.flowSteps.COMPLAINT)) {
			exchangeObj[key] = {
				...value,
				isFlow: config.flowSteps.EXCHANGE,
			}
		}
	}

	return (
		{
			...items.reclamation,
			...exchangeObj,
		} || {}
	)
}

/**
 * getItemsRefund {Function}
 * @description - get refund items
 *
 * */
const getItemsRefund = (items) => {
	let itemsArr = []

	for (let i in items?.refund) {
		itemsArr.push(items?.refund[i])
	}

	return itemsArr
}

/**
 * getItemsExchange {Function}
 * @description - get exchange items
 *
 * */
const getItemsExchange = (items) => {
	let itemsArr = []

	for (let i in items?.exchange) {
		itemsArr.push(items?.exchange[i])
	}

	return itemsArr
}

/**
 * getReclamationItemId {Function}
 * @description - get current item id for continue btn
 *
 * */
const getReclamationItemId = (reclamation, itemId, flowType, nextFlowStep) => {
	let index = null
	let keys = Object.keys(reclamation)

	if (keys.length) {
		let loc = keys.sort().indexOf(String(itemId))
		index = loc < keys.length - 1 && reclamation[keys[loc + 1]]?.orderItemId
	}
	return index ? `complaint/${index}` : nextFlowStep
}

const getItemIndex = (obj) => {
	return Object.keys(obj)[0]
}

class Reclamation extends Component {
	constructor(props) {
		super(props)

		this.reclamationReasonApiKey = React.createRef()
		this.returnOrderItemConditionApiKey = React.createRef()
		this.reclamationImages = React.createRef()
		this.comment = React.createRef()
	}

	componentDidMount() {
		const { items, match, locale } = this.props
		const reclamation = getItemsReclamation(items)
		const { itemIndex = getItemIndex(reclamation) } = match?.params
		const currentItem = reclamation[itemIndex] || {}
		const mainProps = SS.get('shopProperties')
		const isFaqComplaintEnabled =
			mainProps['widget.complaint.faq.enabled'] === 'true' ? true : false

		// set an appropriate flow step
		this.props.setFlowStepperStep('COMPLAINT')
		this.props.getFAQs({
			shopId:
				currentItem && currentItem.shopId
					? currentItem.shopId
					: SS.get('shopId'),
			category: isFaqComplaintEnabled ? 'COMPLAINT_CATEGORY' : 0,
			locale,
		})
		this.props.clearShippingOptions()
	}

	componentWillUnmount() {
		this.props.setFieldToHighlightInToDefault()
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const {
			items,
			partialRequestData = {},
			flowStep,
			wasReasonAdded,
			match,
			nextFlowStep,
			prevFlowStep,
			isAnyFieldToHighlight,
			locale,
		} = this.props
		const reclamation = getItemsReclamation(items)
		const { itemIndex = getItemIndex(reclamation) } = match?.params
		const currentItem = reclamation[itemIndex] || {}
		const currentOrderItemId = currentItem.orderItemId
		const mainProps = SS.get('shopProperties')
		const isFaqComplaintEnabled =
			mainProps['widget.complaint.faq.enabled'] === 'true' ? true : false

		if (prevProps.locale !== locale) {
			this.props.getFAQs({
				shopId:
					currentItem && currentItem.shopId
						? currentItem.shopId
						: SS.get('shopId'),
				category: isFaqComplaintEnabled ? 'COMPLAINT_CATEGORY' : 0,
				locale,
			})
		}

		// send continue partial request on did mount action
		if (prevProps.flowStep !== flowStep) {
			if (
				flowStep === config.flowSteps.COMPLAINT &&
				!wasReasonAdded[currentOrderItemId]
			) {
				console.log('flowStep Return', flowStep, itemIndex)
				this.props.getPartialSteps(partialRequestData)
			}
		}

		// send the partial request in case if reason was selected
		if (
			prevProps.wasReasonAdded !== wasReasonAdded &&
			wasReasonAdded[currentOrderItemId]
		) {
			console.log('flowStep Return wasReasonAdded', flowStep)
			this.props.getPartialSteps(partialRequestData)
		}

		if (prevProps.items !== items || prevProps.itemIndex !== itemIndex) {
			// detect is continue button active
			this.props.updateContinueState(
				isReclamationItemHandled(reclamation[itemIndex])
			)
			// continue button url functionality
			this.props.addContinueUrl(
				getReclamationItemId(
					reclamation,
					itemIndex,
					'reclamation',
					nextFlowStep
				)
			)
		}

		if (prevProps.flowStep !== flowStep) {
			this.props.addBackUrl(prevFlowStep)
		}

		// run functionality to start check was any mandatory field missed
		if (prevProps.isAnyFieldToHighlight !== isAnyFieldToHighlight) {
			if (isAnyFieldToHighlight) {
				let {
					reclamationReasonApiKey,
					returnOrderItemConditionApiKey,
					reclamationImages,
					comment,
				} = currentItem
				let fieldsToHighlight = []

				if (!reclamationReasonApiKey) {
					fieldsToHighlight.push('reclamationReasonApiKey')
				}

				if (!returnOrderItemConditionApiKey) {
					fieldsToHighlight.push('returnOrderItemConditionApiKey')
				}

				if (
					returnOrderItemConditionApiKey !== DIDNT_ARRIVE &&
					reclamationReasonApiKey !== INCORRECT_ITEM
				) {
					if (!reclamationImages || !reclamationImages.length) {
						fieldsToHighlight.push('reclamationImages')
					}
				}

				if (!comment) {
					fieldsToHighlight.push('comment')
				}

				this.props.markFieldToHighlight(fieldsToHighlight)

				if (fieldsToHighlight && fieldsToHighlight.length) {
					let currentMandatoryField = fieldsToHighlight[0]
					this[currentMandatoryField].current.scrollIntoView({
						block: 'center',
						behavior: 'smooth',
					})
				}
			}
		}
	}

	/**
	 * setReason {Function}
	 * @description - set an appropriate reason or condition to the current item
	 *
	 * */
	setReason = (item, type, itemIndex, orderItemId) => {
		//let { items } = this.props
		//const reclamation = getItemsReclamation(items)
		//const currentItem = reclamation[itemIndex] || {}

		this.props.addReasonCondition(
			item.props.defaultMessage,
			type,
			itemIndex,
			orderItemId
		)

		this.props.unmarkFieldToHighlight(type)

		if (
			type === 'returnOrderItemConditionApiKey' &&
			item.props.id === `reclamation.condition.${DIDNT_ARRIVE}`
		) {
			this.props.unmarkFieldToHighlight('reclamationImages')
		}

		if (
			type === 'reclamationReasonApiKey' &&
			item.props.id === `reclamation.reason.${INCORRECT_ITEM}`
		) {
			this.props.unmarkFieldToHighlight('reclamationImages')
		}
	}

	/**
	 * setComment {Function}
	 * @description - set an appropriate comment to the current item
	 *
	 * */
	setComment = (comment, itemIndex) => {
		this.props.addReclamationComment(comment, itemIndex)
		this.props.unmarkFieldToHighlight('comment')
	}

	/**
	 * setReclamationImages {Function}
	 * @description - set an appropriate images to the current item
	 *
	 * */
	setReclamationImages = (images, itemIndex) => {
		this.props.addReclamationImages(images, itemIndex)
		this.props.unmarkFieldToHighlight('reclamationImages')
	}

	/**
	 * removeReclamationImages {Function}
	 * @description - remove an appropriate image to the current item
	 *
	 * */
	removeReclamationImages = (images, itemIndex) => {
		this.props.clearReclamationImages(images, itemIndex)
	}

	onRemoveItemFlow = (flow, orderItemId) => {
		this.props.removeItemFlow({
			flow,
			orderItemId,
		})
	}

	isItemHandled = (item) => {
		let isItemHandled = true
		let {
			comment,
			reclamationImages = [],
			reclamationReasonApiKey,
			returnOrderItemConditionApiKey,
		} = item

		if (
			!comment ||
			!reclamationReasonApiKey ||
			!returnOrderItemConditionApiKey ||
			(returnOrderItemConditionApiKey !== DIDNT_ARRIVE &&
				!reclamationImages?.length)
		) {
			isItemHandled = false
		}

		return isItemHandled
	}

	render() {
		const {
			items = {},
			itemConditions = [],
			reclamationReasons = [],
			partialRequestData = {},
			faqs = [],
			isLoading,
			fieldToHighlight,
			match,
			intl,
			history,
		} = this.props
		const reclamation = getItemsReclamation(items)
		const refund = getItemsRefund(items)
		const exchange = getItemsExchange(items)
		const allComplaintItems = getItemsArray(reclamation)
		const { itemIndex = getItemIndex(reclamation) } = match?.params
		const currentItem = reclamation[itemIndex] || {}
		const {
			reclamationReasonApiKey,
			returnOrderItemConditionApiKey,
			comment,
			reclamationImages,
		} =
			partialRequestData?.returnOrder?.items?.filter(
				(i) => i.orderItemId === itemIndex
			)[0] || currentItem

		/**
		 * ContactFormButton {React Element}
		 * @description - button to call contact form
		 *
		 * */
		const ContactFormButton = React.forwardRef(
			({ open, ...props }, ref) => (
				<ButtonFull dark w100 reference={ref} {...props}>
					<FormattedMessage
						id='reclamation.contact.us.button'
						defaultMessage='Contact {shopName} for help'
						values={{
							shopName:
								getShopPropertiesName() ||
								getTokenData()?.customer?.shopId,
						}}
					/>
				</ButtonFull>
			)
		)

		/**
		 * FaqButton {React Element}
		 * @description - button to call FAQ
		 *
		 * */
		const FaqButton = React.forwardRef(({ open, ...props }, ref) => (
			<ButtonBorder w100 reference={ref} {...props}>
				<FormattedMessage
					id='reclamation.view.all.faqs.button'
					defaultMessage='View all FAQs'
				/>
			</ButtonBorder>
		))

		return (
			<Layout>
				<StepsAnimation>
					<PreviewItemsWrapper>
						{!!(refund && refund.length) && (
							<ItemPreviewFlowSegment>
								<ItemPreviewFlowSegmentTitle>
									<FormattedMessage
										id={`progress.bar.refund`}
										defaultMessage={'Refund'}
									/>
								</ItemPreviewFlowSegmentTitle>
								<ItemPreviewFlowSegmentBody>
									{refund.map((item, key) => {
										let isHandled = this.isItemHandled(item)
										return (
											<ItemPreview
												isActive={false}
												isNextStep={true}
												key={key}
												top30
												isHandled={isHandled}
												reclamationType={true}
												price={item.price}
												name={item.name}
												attributes={item.attributes}
												imageUrl={item.imageUrl}
												orderItemId={item.orderItemId}
												setFlow={item.setFlow}
											/>
										)
									})}
								</ItemPreviewFlowSegmentBody>
							</ItemPreviewFlowSegment>
						)}

						<ItemPreviewFlowSegment>
							<ItemPreviewFlowSegmentTitle isActive={true}>
								<FormattedMessage
									id={`progress.bar.reclamation`}
									defaultMessage={'Reclamation'}
								/>
							</ItemPreviewFlowSegmentTitle>
							<ItemPreviewFlowSegmentBody>
								{allComplaintItems.map((item, key) => {
									let isHandled = this.isItemHandled(item)
									return (
										<ItemPreview
											isActive={
												item.orderItemId ===
												currentItem.orderItemId
											}
											key={key}
											top30
											isHandled={isHandled}
											reclamationType={true}
											price={item.price}
											currency={
												item.defaultCurrency ||
												item.currency
											}
											name={item.name}
											attributes={item.attributes}
											imageUrl={item.imageUrl}
											orderItemId={item.orderItemId}
											setFlow={item.setFlow}
											onClickAction={() => {
												if (isHandled) {
													if (
														item.orderItemId !==
														currentItem.orderItemId
													) {
														history.push(
															`/complaint/${item.orderItemId}`
														)
													}
												}
											}}
											onRemoveAction={() => {
												this.onRemoveItemFlow(
													item.setFlow,
													item.orderItemId
												)
											}}
										/>
									)
								})}
							</ItemPreviewFlowSegmentBody>
						</ItemPreviewFlowSegment>
						{!!(exchange && exchange.length) && (
							<ItemPreviewFlowSegment>
								<ItemPreviewFlowSegmentTitle>
									<FormattedMessage
										id={`progress.bar.progress.bar.exchange`}
										defaultMessage={'Exchange'}
									/>
								</ItemPreviewFlowSegmentTitle>
								<ItemPreviewFlowSegmentBody>
									{exchange.map((item, key) => {
										let isHandled = this.isItemHandled(item)
										return (
											<ItemPreview
												isActive={false}
												isNextStep={true}
												key={key}
												top30
												isHandled={isHandled}
												reclamationType={true}
												price={item.price}
												currency={
													item.defaultCurrency ||
													item.currency
												}
												name={item.name}
												attributes={item.attributes}
												imageUrl={item.imageUrl}
												orderItemId={item.orderItemId}
												setFlow={item.setFlow}
											/>
										)
									})}
								</ItemPreviewFlowSegmentBody>
							</ItemPreviewFlowSegment>
						)}
					</PreviewItemsWrapper>
					<Separator />
					<ControlsWrapper>
						<ControlsWrapperItem>
							<FAQPreview faqs={faqs} />
							<PopupWindow
								trigger={(open) => <FaqButton open={open} />}
								content={<Accordions list={faqs} />}
								title={intl.formatMessage({
									id: 'reclamation.faq.dialog.title',
									defaultMessage:
										'Frequently asked questions',
								})}
								popupType={'faq'}
							/>
						</ControlsWrapperItem>
						<ControlsWrapperItem className='contact-from-item'>
							<PopupWindow
								trigger={(open) => (
									<ContactFormButton open={open} />
								)}
								content={
									<ReclamationContactForm
										item={currentItem}
									/>
								}
								title={
									<FormattedMessage
										id='reclamation.contact.us.dialog.title'
										defaultMessage='Contact {shopName}'
										values={{
											shopName: getShopPropertiesName(),
										}}
									/>
								}
								onClose={() => {
									this.props.clearContactFromMessageSuccess()
								}}
							/>
						</ControlsWrapperItem>
					</ControlsWrapper>
					<ReclamationItemIndexTitle>
						<FormattedMessage
							id='reclamation.defective.products.section.title'
							defaultMessage='My product is defective or non-functioning'
						/>
					</ReclamationItemIndexTitle>
					<ReclamationItemIndexSubTitle>
						<FormattedMessage
							id='reclamation.defective.products.section.text'
							defaultMessage='Not satisfied? Please tell us why so we can improve our service to you.'
						/>
					</ReclamationItemIndexSubTitle>
					<ReclamationReasonCondition
						ref={this.reclamationReasonApiKey}
						key={`${itemIndex}_reclamationReasonApiKey`}
						type='reclamationReasonApiKey'
						isHighlighted={
							fieldToHighlight['reclamationReasonApiKey']
						}
						title={
							<FormattedMessage
								id='reclamation.choose.reason.select.text'
								defaultMessage="What's the reason for your return?"
							/>
						}
						defaultValue={reclamationReasonApiKey}
						items={reclamationReasons.map((reason) => (
							<FormattedMessage
								id={`reclamation.reason.${reason}`}
								defaultMessage={reason}
							/>
						))}
						itemIndex={itemIndex}
						orderItemId={currentItem.orderItemId}
						onClickAction={this.setReason}
						isLoading={isLoading && !reclamationReasons.length}
					/>
					<ReclamationReasonCondition
						ref={this.returnOrderItemConditionApiKey}
						key={`${itemIndex}_returnOrderItemConditionApiKey`}
						type='returnOrderItemConditionApiKey'
						isHighlighted={
							fieldToHighlight['returnOrderItemConditionApiKey']
						}
						title={
							<FormattedMessage
								id='reclamation.choose.direction.preview.text'
								defaultMessage="What's the condition of the product?"
							/>
						}
						defaultValue={returnOrderItemConditionApiKey}
						items={itemConditions.map((condition) => (
							<FormattedMessage
								id={`reclamation.condition.${condition}`}
								defaultMessage={condition}
							/>
						))}
						itemIndex={itemIndex}
						orderItemId={currentItem.orderItemId}
						onClickAction={this.setReason}
						isLoading={isLoading && !itemConditions.length}
					/>
					<Separator />
					<Title
						ref={this.reclamationImages}
						isHighlighted={fieldToHighlight['reclamationImages']}
					>
						<FormattedMessage
							id='reclamation.file.upload.preview.text.required'
							defaultMessage='Do you have a picture of the issue?'
						/>
					</Title>
					<UploadPhoto
						key={`${itemIndex}_image_upload`}
						buttonName={
							<FormattedMessage
								id='reclamation.file.upload.button'
								defaultMessage='Select image to upload'
							/>
						}
						defaultValue={reclamationImages}
						itemIndex={itemIndex}
						afterLoadingAction={this.setReclamationImages}
						afterRemoveAction={this.removeReclamationImages}
					/>
					<Title
						ref={this.comment}
						isHighlighted={fieldToHighlight['comment']}
					>
						<FormattedMessage
							id='reclamation.more.info.required'
							defaultMessage='Additional information?'
						/>
					</Title>
					<Description
						key={`${itemIndex}_comment`}
						rows='5'
						className='mb-4'
						placeholder={intl.formatMessage({
							id: 'reclamation.more.info.refund.placeholder',
							defaultMessage:
								"Do you have more information you'd like to add to help understand your issue?",
						})}
						defaultValue={comment}
						onChange={(e) => {
							this.setComment(e.target.value, itemIndex)
						}}
					/>
				</StepsAnimation>
			</Layout>
		)
	}
}

function mapStateToProps({ steps, complaint, root }) {
	return {
		...complaint,
		items: steps.items,
		itemConditions: steps.itemConditions,
		reclamationReasons: steps.reclamationReasons,
		faqs: steps.faqs,
		isLoading: steps.isLoading,
		partialRequestData: steps.partialRequestData,
		flowStep: steps.flowStep,
		wasReasonAdded: steps.wasReasonAdded,
		nextFlowStep: steps.nextFlowStep,
		prevFlowStep: steps.prevFlowStep,
		locale: root.locale,
	}
}

function matchDispatchToProps(dispatcher) {
	return bindActionCreators(
		{
			addReasonCondition,
			addReclamationComment,
			addReclamationImages,
			clearReclamationImages,
			unmarkFieldToHighlight,
			removeItemFlow,
			clearContactFromMessageSuccess,
			getPartialSteps,
			updateContinueState,
			addContinueUrl,
			addBackUrl,
			markFieldToHighlight,
			setFlowStepperStep,
			getFAQs,
			clearShippingOptions,
			setFieldToHighlightInToDefault,
		},
		dispatcher
	)
}

const sippingConnect = connect(mapStateToProps, matchDispatchToProps)

export default compose(sippingConnect, injectIntl)(Reclamation)
